import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetNonCompliancesByComplaintFetchUrl,
  GetNonCompliancesByComplianceInvestigationFetchUrl,
  GetNonCompliancesByIncidentFetchUrl,
  GetNonCompliancesByLicenseeReturnFetchUrl,
  GetNonCompliancesBySiteVisitFetchUrl,
  INonCompliance,
} from "../../api/INonCompliance";
import { Grid } from "../Grid";
import { NonCompliancesGridProps } from "./NonCompliancesGridProps";

const NonCompliancesGrid = ({
  relatedRecordType,
  relatedRecordId,
  licenceProfile,
}: NonCompliancesGridProps) => {
  const GetUrlForNonCompliance = (
    profileNumber: string,
    nonCompliance: INonCompliance
  ) => {
    return `/licence-profile/${profileNumber}/compliance/non-compliance/${nonCompliance.noncomplianceid}`;
  };

  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      switch (relatedRecordType) {
        case "Licensee Return":
          return GetNonCompliancesByLicenseeReturnFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
        case "Complaint":
          return GetNonCompliancesByComplaintFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
        case "Incident":
          return GetNonCompliancesByIncidentFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
        case "Site Visit":
          return GetNonCompliancesBySiteVisitFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
        case "Compliance Investigation":
        default:
          return GetNonCompliancesByComplianceInvestigationFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
      }
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(relatedRecordId);

  const tableColumnsBig: Column<Record<string, INonCompliance>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "reference",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForNonCompliance(
                  licenceProfile.profileNo,
                  rowInfo.row.original
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Date Non Compliance Occurred",
      accessor: "dateofnoncompliance",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Date Issued by EPA",
      accessor: "datesubmitted",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Non Compliance Type",
      accessor: "type",
      Filter: false,
    },
  ];

  const tableColumnsSmall: Column<Record<string, INonCompliance>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "reference",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForNonCompliance(
                  licenceProfile.profileNo,
                  rowInfo.row.original
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Non Compliance Type",
      accessor: "type",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { NonCompliancesGrid };
